export default __webpack_public_path__ + "static/media/019-call-center-1.5e936963.png";